'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Action types
 */

var TIMEOUT = 'TIMEOUT';
var INTERVAL = 'INTERVAL';
var RAF = 'RAF';
var CLEAR_TIMEOUT = 'CLEAR_TIMEOUT';
var CLEAR_INTERVAL = 'CLEAR_INTERVAL';
var CLEAR_RAF = 'CLEAR_RAF';

/**
 * Vars
 */

var types = [TIMEOUT, INTERVAL, RAF, CLEAR_TIMEOUT, CLEAR_INTERVAL, CLEAR_RAF];

/**
 * Timeout
 */

function timeoutMiddleware() {
  var api = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var handle = handler(api);
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        return types.indexOf(action.type) !== -1 ? Promise.resolve(handle(dispatch, action)) : next(action);
      };
    };
  };
}

function handler(_ref2) {
  var _ref2$interval = _ref2.interval;
  var interval = _ref2$interval === undefined ? world().setInterval : _ref2$interval;
  var _ref2$timeout = _ref2.timeout;
  var timeout = _ref2$timeout === undefined ? world().setTimeout : _ref2$timeout;
  var _ref2$raf = _ref2.raf;
  var raf = _ref2$raf === undefined ? world().requestAnimationFrame : _ref2$raf;
  var _ref2$cancelInterval = _ref2.cancelInterval;
  var cancelInterval = _ref2$cancelInterval === undefined ? clearInterval : _ref2$cancelInterval;
  var _ref2$cancelTimeout = _ref2.cancelTimeout;
  var cancelTimeout = _ref2$cancelTimeout === undefined ? world().clearTimeout : _ref2$cancelTimeout;
  var _ref2$cancelRaf = _ref2.cancelRaf;
  var cancelRaf = _ref2$cancelRaf === undefined ? world().cancelAnimationFrame : _ref2$cancelRaf;

  return function (dispatch, action) {
    var fn = compose(dispatch, action.payload.cb);

    switch (action.type) {
      case TIMEOUT:
        return timeout(fn, action.payload.value);
      case RAF:
        return raf(fn);
      case INTERVAL:
        return interval(fn, action.payload.value);
      case CLEAR_TIMEOUT:
        return cancelTimeout(action.payload.value);
      case CLEAR_INTERVAL:
        return cancelInterval(action.payload.value);
      case CLEAR_RAF:
        return cancelRaf(action.payload.value);
    }
  };
}

function world() {
  return typeof window === 'undefined' ? global : window;
}

function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(function (memo, fn) {
    return function (arg) {
      return memo(fn(arg));
    };
  }, function (arg) {
    return arg;
  });
}

/**
 * Action creators
 */

function raf(cb) {
  return {
    type: RAF,
    payload: {
      cb: cb
    }
  };
}

function timeout(cb, ms) {
  return {
    type: TIMEOUT,
    payload: {
      cb: cb,
      value: ms
    }
  };
}

function interval(cb, ms) {
  return {
    type: INTERVAL,
    payload: {
      cb: cb,
      value: ms
    }
  };
}

function cancelTimeout(id) {
  return {
    type: CLEAR_TIMEOUT,
    payload: {
      value: id
    }
  };
}

function cancelInterval(id) {
  return {
    type: CLEAR_INTERVAL,
    payload: {
      value: id
    }
  };
}

function cancelAnimationFrame(id) {
  return {
    type: CLEAR_RAF,
    payload: {
      value: id
    }
  };
}

/**
 * Exports
 */

exports.default = timeoutMiddleware;
exports.raf = raf;
exports.timeout = timeout;
exports.interval = interval;
exports.cancelTimeout = cancelTimeout;
exports.cancelInterval = cancelInterval;
exports.cancelAnimationFrame = cancelAnimationFrame;